/* eslint-disable no-param-reassign */
import Phaser from 'phaser';
import gameData from '../gameData';
import CloudParticle from './CloudParticle';
import SnowParticle from './SnowParticle';

export default class ParticleBoard extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   * @param {number} w dropContainer width
   * @param {number} h dropContainer height
   */
  constructor(scene, w, h) {
    super(scene);

    this.dropWidth = w;
    this.dropHeight = h;

    this.baseMask = new Phaser.GameObjects.Graphics(this.scene, { fillStyle: { color: 0xffffff } }).fillRoundedRect(0,0,this.dropWidth, this.dropHeight, 5);
    this.mask = new Phaser.Display.Masks.GeometryMask(this.scene, this.baseMask);

    // wait one frame and then position the mask (only needed initially)
    this.scene.events.once(Phaser.Scenes.Events.POST_UPDATE, () => {
      const maskPos = this.getWorldTransformMatrix().transformPoint(0,0);
      this.baseMask.setPosition(maskPos.x, maskPos.y);
    });

    this.psettings = gameData.settings.PARTICLE_SETTINGS;
    this.particles = [];
    this.particlePool = [];
    this.particleSpawnCount = this.psettings.spawnCount;

    this.particleWaiter = this.psettings.waiter;
    this.particleWaiterMin = this.psettings.waiterMin;
    if (!this.particleWaiterMin) this.particleWaiterMin = this.particleWaiter;
    this.particleWaiterMax = this.psettings.waiterMax;
    if (!this.particleWaiterMax) this.particleWaiterMax = this.particleWaiter;
    this.timeSinceLastParticle = 400;
    if (gameData.settings.PARTICLE_TYPE === 'Cloud') {
      for (let i = 0; i < 50; i++) this.particlePool.push(new CloudParticle(this.scene, this));
      this.particleSetupFunction = this.makeCloud;
    }
    else if (gameData.settings.PARTICLE_TYPE === 'Snowflake') {
      for (let i = 0; i < 50; i++) this.particlePool.push(new SnowParticle(this.scene, this));
      this.particleSetupFunction = this.makeSnow;
    }
  }

  makeCloud(startingLocMin, startingLocMax) {
    const item = this.particlePool.pop();

    const pType = Phaser.Math.Between(1, this.psettings.typeCount);

    const cloudLayers = [];
    let cloudprops = { minScale: 2, maxScale: 5, minSpeed: 10, maxSpeed: 20, minAlpha: 2, maxAlpha: 4 };
    cloudLayers.push(cloudprops);
    cloudprops = { minScale: 5, maxScale: 7, minSpeed: 22, maxSpeed: 39, minAlpha: 5, maxAlpha: 6 };
    cloudLayers.push(cloudprops);
    cloudprops = { minScale: 8, maxScale: 10, minSpeed: 40, maxSpeed: 49, minAlpha: 7, maxAlpha: 10 };
    cloudLayers.push(cloudprops);
    const whichLayer = cloudLayers[Phaser.Math.Between(1, cloudLayers.length) - 1];

    const speed = Phaser.Math.Between(whichLayer.minSpeed, whichLayer.maxSpeed);
    const startAlpha = Phaser.Math.Between(whichLayer.minAlpha, whichLayer.maxAlpha) / 10;
    const scale = Phaser.Math.Between(whichLayer.minScale, whichLayer.maxScale) / 10;

    const startPos = Phaser.Math.Between(startingLocMin,startingLocMax);
    item.reset(`Particle_${pType}`, speed, startPos, this.dropWidth, startAlpha, scale);
    this.particles.push(item);
  };

  makeSnow(startingLocMin, startingLocMax) {
    const item = this.particlePool.pop();

    const pType = Phaser.Math.Between(1, this.psettings.typeCount);
    const speed = Phaser.Math.Between(this.psettings.minSpeed, this.psettings.maxSpeed);
    let startPos;
    if (this.psettings.movement === 0) {
      startPos = Phaser.Math.Between(50,this.dropWidth - 50);
    }
    else if (this.psettings.movement === 1) {
      startPos = Phaser.Math.Between(startingLocMin,startingLocMax);
    }
    else {
      console.log('no movement setting for particle.');
    }

    const startAlpha = Phaser.Math.Between(3,8) / 10;
    const scale = Phaser.Math.Between(5,8) / 10;
    item.reset(`Particle_${pType}`, speed, startPos, 500, startAlpha, scale);
    this.particles.push(item);
  };

  resetParticle(itemRef) {
    itemRef.visible = false;
    this.particlePool.push(itemRef);

    const i = this.particles.indexOf(itemRef);
    this.particles.splice(i,1);
  };

  tick(t, v) {
    const len = this.particles.length - 1;
    for (let i = len; i >= 0; i--) {
      this.particles[i].tick(v);
    }

    if (t - this.timeSinceLastParticle > this.particleWaiter) {
      this.timeSinceLastParticle = t;
      for (let i = 0; i < this.particleSpawnCount; i++) {
        this.particleSetupFunction(this.psettings.locRanges[0].min,this.psettings.locRanges[0].max, i);
      }
      this.particleWaiter = Phaser.Math.Between(this.particleWaiterMin, this.particleWaiterMax);
    }
  };
}